import React, { FC, useContext, useState } from 'react';

import { H3, NumberInput, Toggle } from '@smartshell/ui-kit';
import { isEqual } from 'lodash';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './Tips.module.scss';

export const Tips: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { tipsValues, tipsEnabled },
    },
    actions: { setSetting },
  } = useContext(SettingsContext);

  const [errors, setErrors] = useState<Record<string, string | undefined>>({});
  const [newTipsValues, setNewTipsValues] = useState(tipsValues);

  return (
    <div className={s.container}>
      <Toggle
        label={t('setting.tips.title')}
        description={t('setting.tips.description')}
        value={tipsEnabled}
        onChange={(value: string) => {
          setSetting({
            alias: ESettingsAliases.TIPS_ENABLED,
            value: value ? '1' : '0',
          });
        }}
        variant="secondary"
        emptyBg
      />
      {tipsEnabled && (
        <div className={s.tips}>
          {tipsValues.map((value, index) => (
            <div className={s.inputContainer} key={index}>
              <div className={s.left_block}>
                <H3>
                  {t('sum')} {index + 1}
                </H3>
              </div>
              <NumberInput
                value={value}
                variant="secondary"
                onChange={(value) => {
                  if (value === '' || value < 1) {
                    setErrors((prev) => ({
                      ...prev,
                      [index]: t('errors.min', 1),
                    }));
                  } else if (
                    newTipsValues.some((tip) => tip === value) &&
                    newTipsValues[index] !== value
                  ) {
                    setErrors((prev) => ({
                      ...prev,
                      [index]: t('errors.tips.not_unique'),
                    }));
                  } else {
                    setErrors((prev) => ({
                      ...prev,
                      [index]: undefined,
                    }));
                  }

                  setNewTipsValues((prev) =>
                    prev.map((tip, i) => (i === index ? Number(value) : tip))
                  );
                }}
                onBlur={() => {
                  if (!errors[index] && !isEqual(newTipsValues, tipsValues)) {
                    return setSetting({
                      alias: ESettingsAliases.TIPS_VALUES,
                      value: JSON.stringify(
                        newTipsValues.sort((a, b) => a - b)
                      ),
                    });
                  }
                }}
                errorWrapperClassName={s.input}
                error={errors[index]}
                bordered
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
